import moment from 'moment'
export const formatDateWithDelta = (currentDate: Date, delta: number): string =>{
    currentDate.setMinutes(currentDate.getMinutes() + delta)
    const localDateString = currentDate.toLocaleString('ja-JP')
    const momentDate = moment(localDateString, 'YYYY/MM/DD h:mm:ss A')
    return momentDate.format('YYYY-MM-DDTHH:mm')
}